import { useDispatch } from "react-redux";
import { logoutAction } from "../../../store/slices/auth/logoutAction";
import LanguageSelector from "../i18n/LanguageSelector";
import FullScreen from "./FullScreen";
import RecentObjects from "./RecentObjects";
import ToggleMenu from "./ToggleMenu";
import Activities from "./../activities/Activities";

const Header = () => {
  const dispatch = useDispatch();

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logoutAction());
  };

  return (
    <header id="header">
      <div id="logo-group">
        <span id="logo" style={{ marginTop: 7 }}>
          <img src={"/assets/img/logo.png"} alt="logo" />
        </span>
      <Activities />
      </div>
      <RecentObjects />
      <div className="pull-right">
        <ToggleMenu className="btn-header pull-right" />
        <div id="logout" className="btn-header transparent pull-right">
          <span>
            <a href="/" title="Sign Out" onClick={(e) => handleLogout(e)}>
              <i className="fa fa-sign-out" />
            </a>
          </span>
        </div>
        <FullScreen className="btn-header transparent pull-right" />
        <LanguageSelector />
      </div>
    </header>
  );
};
export default Header;
